"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.EmptyNote = exports.Notes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var highlighted_content_1 = require("../highlighted-content/highlighted-content");
var note_frame_1 = require("./note-frame");
var pdf_frame_1 = require("./pdf-frame");
var case_alert_1 = require("../case-alert/case-alert");
var ui_common_1 = require("@codametrix/ui-common");
var Note = /** @class */ (function (_super) {
    __extends(Note, _super);
    function Note() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Note.prototype.render = function () {
        var note = this.props.note;
        var _a = note.segments, segments = _a === void 0 ? [] : _a, _b = note.spans, spans = _b === void 0 ? [] : _b, document_id = note.document_id, filetype = note.filetype;
        var content = ((0, jsx_runtime_1.jsx)(highlighted_content_1.HighlightedContent, { segments: segments, spans: spans, id: document_id }));
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "report case-note qa-report sensitive-data" }, { children: [content, (0, jsx_runtime_1.jsx)("div", { className: "divider-space" })] })));
    };
    Note.displayName = 'Note';
    return Note;
}(react_1.Component));
function NotePlainText(_a) {
    var note = _a.note;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "report case-note qa-report sensitive-data", style: { whiteSpace: 'pre-line' } }, { children: note.content })));
}
var EmptyNote = function () {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "content-vacant qa-empty-note" }, { children: [(0, jsx_runtime_1.jsx)("h4", { children: "No document available" }), (0, jsx_runtime_1.jsx)("h4", { children: "Please contact CodaMetrix if you expect to see a document for this case" }), (0, jsx_runtime_1.jsx)("p", { children: " support@codametrix.com " })] })));
};
exports.EmptyNote = EmptyNote;
EmptyNote.displayName = 'EmptyNote';
var sortNotes = function (a, b) {
    if (a.primary === true)
        return -1;
    if (b.primary === true)
        return 1;
    return b.id - a.id;
};
var Notes = function (props) {
    var _a = props.notes, notes = _a === void 0 ? [] : _a, noteRefs = props.noteRefs;
    notes.sort(sortNotes);
    var noteContent = notes.map(function (note) {
        var _a;
        var synthKey = "".concat(note === null || note === void 0 ? void 0 : note.id);
        // {
        //   !note.filename && !note.description;
        // }
        var content;
        var notices = false;
        if (note.filetype === 'text/html') {
            content = (0, jsx_runtime_1.jsx)(note_frame_1.NoteFrame, { iframeNote: note }, synthKey);
        }
        else if (note.filetype === 'application/pdf') {
            content = (0, jsx_runtime_1.jsx)(pdf_frame_1.PDFFrame, { pdfContent: note }, synthKey);
        }
        // CQA conditionals will maintain backwards compatability for existing Note displays
        else if (note.filetype === 'text/plain' &&
            note.benchmode === ui_common_1.commonEnums.BenchMode.GRADE) {
            content = NotePlainText({ note: note });
        }
        else {
            // text/plain or null case
            content = (0, jsx_runtime_1.jsx)(Note, { note: note }, synthKey);
        }
        var documentNotices = (_a = note === null || note === void 0 ? void 0 : note.documentNotices) !== null && _a !== void 0 ? _a : [];
        if (documentNotices.length) {
            notices = documentNotices.map(function (notice, idx) { return ((0, jsx_runtime_1.jsx)(case_alert_1.CaseAlert, __assign({ alertType: notice.level, alertSize: "sm" }, { children: notice.message }), "document-notice-".concat(idx))); });
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: noteRefs ? noteRefs[note.document_id] : undefined, className: "notes-inner ".concat(note.document_id) }, { children: [notices, content, !note.filename && !note.description ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "notes-heading" }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "note-text" }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "note-name" }, { children: [" End of ", note.filename] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "note-description" }, { children: !note.description ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' — ', note.description] })) }))] })), (0, jsx_runtime_1.jsx)("hr", { className: "notes-divider" })] })))] }), note.document_id));
    });
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (noteContent === null || noteContent === void 0 ? void 0 : noteContent.length) ? noteContent : (0, jsx_runtime_1.jsx)(EmptyNote, {}) });
};
exports.Notes = Notes;
Notes.displayName = 'Notes';
//# sourceMappingURL=case-note.js.map